import angular from 'angular'

import { keys, difference, intersection } from 'lodash-es'

import AttrsObserver from './attrs-observer'

angular
  .module('ggs.utils')
  .factory('portalQs', portalQsProvider)
  .factory('portalAttr', portalAttrProvider)
  .factory('$portalElement', $portalElementProvider)

const GLOBAL_ATTR = 'data-portal'
const IGNORE_ATTRS = ['style']

function portalQsProvider(portalAttr) {
  return `[${portalAttr}]`
}

function portalAttrProvider(addIdPrefix) {
  return addIdPrefix('portal')
}

function $portalElementProvider($rootElement, $rootScope, portalAttr) {
  const attrsObserver = AttrsObserver($rootElement)
  const portalElement = document.createElement('div')

  portalElement.setAttribute(GLOBAL_ATTR, true)
  portalElement.setAttribute(portalAttr, true)
  applyAttrs(attrsObserver.getAttrs())
  document.body.appendChild(portalElement)

  attrsObserver.on(applyAttrs)
  $rootScope.$on('$destroy', onDestroy)

  return angular.element(portalElement)

  function onDestroy() {
    attrsObserver.off(applyAttrs)
    // domh.remove.notStrict cannot be used as domh depends on this module
    if (portalElement.parentNode) portalElement.parentNode.removeChild(portalElement)
  }

  function applyAttrs(curr, last = {}) {
    const currKeys = difference(keys(curr), IGNORE_ATTRS)
    const lastKeys = difference(keys(last), IGNORE_ATTRS)

    const stbKeys = intersection(currKeys, lastKeys)
    const newKeys = difference(currKeys, lastKeys)
    const delKeys = difference(lastKeys, currKeys)

    stbKeys.forEach((key) => portalElement.setAttribute(key, curr[key]))
    newKeys.forEach((key) => portalElement.setAttribute(key, curr[key]))
    delKeys.forEach((key) => portalElement.removeAttribute(key))
  }
}
